import React, { Component } from "react";
import axios from "axios";
import InfoItem from "~app/models/info-item";
import "react-bulma-components/dist/react-bulma-components.min.css";
import { Card, Form, Icon, Input, Select, Tabs } from "antd";
import "antd/dist/antd.css";
import { Link } from "react-router-dom";
import v from "voca";
import { withRouter } from "react-router";
import compose from "lodash/fp/compose";
import WithMediaLinks from "~app/hoc/medialinks";
import Imagable from "~app/hoc/imagable";
import Translatable from "~app/hoc/translatable";
import SortableTableTransfer from "~app/components/sortabletabletransfer";
import TextEditor from "~app/components/text-editor";

const { TabPane } = Tabs;
const { Option } = Select;

const formItemLayout = {
    labelCol: { span: 24 },
    wrapperCol: { span: 24 },
};

const identifiers = ["A", "B", "C", "D", "E", "F"];

const leftObjectColumns = function leftObjectColumns(t) {
    return [
        {
            key: "internal",
            title: v.titleCase(t("name_internal")),
            render: object => object.internal || "-",
        },
        {
            key: "infoItem",
            title: v.titleCase(t("info_item")),
            render: object => {
                return object.infoItem && object.infoItem.internal || "-";
            },
        },
    ];
};

const rightObjectColumns = function rightObjectColumns(t) {
    return [
        {
            key: "internal",
            title: v.titleCase(t("name_internal")),
            render: object => <Link to={"/objects/" + object.id}>{object.internal || "-"}</Link>,
        },
        {
            key: "published",
            title: v.titleCase(t("published")),
            render: object => {
                return object.published && <Icon type="eye"/> || <Icon type="eye-invisible"/>;
            },
        },
        {
            key: "top",
            title: v.titleCase(t("object_top")),
            render: object => {
                return object.isTop && <Icon type="star"/>;
            },
        },
    ];
};

class Edit extends Component {
    constructor(props) {
        super(props);
        this.state = {
            infoItem: null,
            objects: [],
        };
        this.handleChange = this.handleChange.bind(this);
        this.save = this.save.bind(this);
        this.goBack = this.goBack.bind(this);
        this.setChange = this.setChange.bind(this);
        this.onChange = this.onChange.bind(this);
        this.setPublished = this.setPublished.bind(this);
        this.handleInternal = this.handleInternal.bind(this);
        this.onObjectsSort = this.onObjectsSort.bind(this);
    }

    goBack() {
        this.props.history.goBack();
    }

    onChange(ids) {
        const { infoItem } = this.state;
        infoItem.objectIds = ids;
        this.setState({ infoItem });
    }

    handleInternal(internal) {
        const { infoItem } = this.state;
        infoItem.internal = internal;
        this.setState({ infoItem });
    }

    async componentDidMount() {
        this.setState({
            infoItem: await this.getInfoItem(),
            objects: await this.getObjects(),
        });
    }

    handleChange(event) {
        const { target } = event;
        const { infoItem } = this.state;
        infoItem[target.name] = target.value;
        this.setState({
            infoItem,
        });
    }

    async getInfoItem() {
        let infoItem = this.props.location.state && this.props.location.state.infoItem || null;
        if (infoItem !== null) {
            return new InfoItem(infoItem);
        }
        const infoItemId = this.props.match.params.id;
        if (infoItemId) {
            const result = await axios.get(`/api/v1/infoitems/${infoItemId}`);
            return new InfoItem(result.data);
        }
        infoItem = new InfoItem();
        return infoItem;
    }

    async getObjects() {
        const result = await axios.get("/api/v1/showcases/objects");
        return result.data;
    }

    async save() {
        const { form } = this.props;
        form.validateFields(async (err, values) => {
            if (!err) {
                const { infoItem } = this.state;
                infoItem.published = true;
                infoItem.internal = values.internal;
                infoItem.identifier = values.identifier;
                infoItem.title = values.title;
                infoItem.summary = values.summary;
                infoItem.text = values.text;
                infoItem.textButton = values.textButton;
                const data = {
                    infoItem,
                };
                await axios.post(infoItem.id ? `/api/v1/infoitems/${infoItem.id}` : "/api/v1/infoitems", data);
                this.goBack();
            }
        });
    }

    setPublished(value) {
        const { infoItem } = this.state;
        infoItem.published = value;
        this.setState({ infoItem });
    }

    setChange(val) {
        const { infoItem } = this.state;
        infoItem.title = val;
        this.setState({ infoItem });
    }

    async onObjectsSort(objectIds) {
        for (const objectId of objectIds) {
            const data = {
                object: {
                    position: objectIds.indexOf(objectId),
                },
            };
           await axios.patch(`/api/v1/showcase/objects/${objectId}`, data);
        }
        const { infoItem } = this.state;
        const result = await axios.get(`/api/v1/infoitems/${infoItem.id}`);
        this.setState({ infoItem: new InfoItem(result.data) });
    }

    render() {
        const { t, form, languages, currentLanguage, translation } = this.props;
        const { infoItem, objects } = this.state;
        const { getFieldDecorator } = form;
        return (
            infoItem
            && (
                <div>
                    <Form {...formItemLayout}>
                        <h1 className="title">{infoItem.internal}</h1>
                        <Card title={v.titleCase(t("property_plural"))}>
                            <Form.Item label={v.titleCase(t("name_internal"))}>
                                {getFieldDecorator("internal", {
                                    initialValue: infoItem.internal,
                                    rules: [
                                        {
                                            required: true,
                                            message: v.capitalize(t("error_required")),
                                        },
                                    ],
                                })(
                                    <Input placeholder={v.titleCase(t("name_internal"))}/>
                                )}
                            </Form.Item>
                        </Card>
                        <Tabs defaultActiveKey={currentLanguage} animated={false} className="mt20">
                            {languages.map(language => (
                                <TabPane tab={language.name} key={language.key}>
                                    <Card title={v.titleCase(t("content"))}>
                                        <Form.Item label={v.titleCase(t("title"))}>
                                            {getFieldDecorator("title[" + language.key + "]", {
                                                initialValue: infoItem.title[language.key],
                                            })(
                                                <Input placeholder={v.titleCase(t("title"))}/>
                                            )}
                                        </Form.Item>
                                        <Form.Item label={v.titleCase(t("summary"))}>
                                            {getFieldDecorator("summary[" + language.key + "]", {
                                                initialValue: infoItem.summary[language.key] || null,
                                            })(
                                                <TextEditor placeholder={v.titleCase(t("summary"))}/>
                                            )}
                                        </Form.Item>
                                        <Form.Item label={v.titleCase(t("text"))}>
                                            {getFieldDecorator("text[" + language.key + "]", {
                                                initialValue: infoItem.text[language.key] || null,
                                            })(
                                                <TextEditor placeholder={v.titleCase(t("text"))}/>
                                            )}
                                        </Form.Item>
                                        <Form.Item label={v.titleCase(t("text_button"))}>
                                            {getFieldDecorator("textButton[" + language.key + "]", {
                                                initialValue: infoItem.textButton[language.key] || null,
                                            })(
                                                <Input placeholder={v.titleCase(t("text_button"))} maxLength={45}/>
                                            )}
                                        </Form.Item>
                                    </Card>
                                </TabPane>
                            ))}
                        </Tabs>
                        <Card title={v.titleCase(t("object_plural"))} className="mt20" hidden={true}>
                            <Form.Item>
                                {infoItem.objects &&
                                <SortableTableTransfer
                                    onSort={this.onObjectsSort}
                                    models={infoItem.objects}
                                    titles={[v.titleCase(t("object_unselected_plural")), v.titleCase(t("object_selected_plural"))]}
                                    rowKey={object => object.id}
                                    dataSource={objects}
                                    targetKeys={infoItem.objectIds}
                                    onChange={this.onChange}
                                    leftColumns={leftObjectColumns(t)}
                                    rightColumns={rightObjectColumns(t)}
                                    showSearch={true}
                                    filterOption={(input, option) => {
                                        return translation(option.title)
                                            ?.toLowerCase()
                                            .includes(input.toLowerCase()) || option.internal && option.internal.toLowerCase()
                                            .includes(input.toLowerCase());
                                    }}
                                />
                                }
                            </Form.Item>
                        </Card>
                        <div className="field is-grouped is-pulled-right mt20">
                            <div className="control">
                                <button className="button is-success" onClick={this.save}>{v.titleCase(t("save"))}</button>
                            </div>
                            <div className="control">
                                <button className="button" onClick={this.goBack}>{v.titleCase(t("cancel"))}</button>
                            </div>
                        </div>
                    </Form>
                </div>
            )
        );
    }
}

export default compose(WithMediaLinks, Imagable, Translatable, withRouter, Form.create({ name: "edit" }))(Edit);
